import { useEffect } from 'react';
import { State, useStore } from 'store';

import fetchDashboardUsers from 'store/fetchDashboardUsers';

import IAsync from 'types/IAsync';
import IUserSummary from 'types/IUserSummary';

export default function useDashboardUsersAsync(): IAsync<IUserSummary[]> {
  const usersAsync = useStore((state: State) => state.dashboard.usersAsync);

  useEffect(() => {
    fetchDashboardUsers();
  }, []);

  return usersAsync;
}
